<div class="flex flex-col gap-6 py-6">
  <div class="flex flex-col gap-4 rounded-2xl border border-shikenso-purple-base-12 p-4">
    <div>
      <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.groups.activeUsersCard.title' | translate }}</h4>
      <p class="text-sm text-shikenso-purple-base-60">
        {{ 'pages.admin.eventAnalytics.groups.activeUsersCard.subtitle' | translate }}
      </p>
    </div>

    <app-stacked-bars [segments]="activeUsersSegments()" [loading]="store.groupsLoading$()" [showZeroBars]="true" />
  </div>

  <div class="flex flex-col gap-4 rounded-2xl border border-shikenso-purple-base-12 p-4">
    <div>
      <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.groups.contentCreation.title' | translate }}</h4>
      <p class="text-sm text-shikenso-purple-base-60">
        {{
          'pages.admin.eventAnalytics.groups.contentCreation.subtitle'
            | translate: { count: totalGroupsCount() > 5 ? 5 : totalGroupsCount() }
        }}
      </p>
    </div>

    <div class="grid grid-cols-1 gap-6 min-[1280px]:grid-cols-2 min-[1640px]:grid-cols-3">
      <div class="flex flex-col items-center gap-3 min-[1280px]:items-start">
        <h5 class="text-sm font-medium">
          {{ 'pages.admin.eventAnalytics.groups.contentCreation.campaignsCreated' | translate }}
        </h5>
        <app-circular-graph
          [data]="campaignsCreatedGraphData()"
          [colorMap]="rankColorMap"
          [nameOverrides]="campaignsCreatedNameOverrides()"
          [legendEntries]="campaignsCreatedRanking()"
          [legendValueBold]="true"
          [includeBonusInMainSeries]="true"
          [showPercentage]="false"
          [showTotal]="true"
          [totalCountCentered]="true"
          [loading]="store.groupsLoading$()"
        />
      </div>

      <div class="flex flex-col items-center gap-3 min-[1280px]:items-start">
        <h5 class="text-sm font-medium">
          {{ 'pages.admin.eventAnalytics.groups.contentCreation.reportsCreated' | translate }}
        </h5>
        <app-circular-graph
          [data]="reportsCreatedGraphData()"
          [colorMap]="rankColorMap"
          [nameOverrides]="reportsCreatedNameOverrides()"
          [legendEntries]="reportsCreatedRanking()"
          [legendValueBold]="true"
          [includeBonusInMainSeries]="true"
          [showPercentage]="false"
          [showTotal]="true"
          [totalCountCentered]="true"
          [loading]="store.groupsLoading$()"
        />
      </div>

      <div
        class="col-span-1 flex flex-col items-center gap-3 min-[1280px]:col-span-2 min-[1640px]:col-span-1 min-[1640px]:items-stretch"
      >
        <h5 class="text-sm font-medium">
          {{ 'pages.admin.eventAnalytics.groups.contentCreation.briefingsCreated' | translate }}
        </h5>
        <app-circular-graph
          [data]="briefingsCreatedGraphData()"
          [colorMap]="rankColorMap"
          [nameOverrides]="briefingsCreatedNameOverrides()"
          [legendEntries]="briefingsCreatedRanking()"
          [legendValueBold]="true"
          [includeBonusInMainSeries]="true"
          [showPercentage]="false"
          [showTotal]="true"
          [totalCountCentered]="true"
          [loading]="store.groupsLoading$()"
        />
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-4 rounded-2xl border border-shikenso-purple-base-12 p-4">
    <div class="flex items-center justify-between">
      <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.groups.table.title' | translate }}</h4>
      <span class="text-xs text-shikenso-purple-base-60">
        {{ 'pages.admin.eventAnalytics.groups.table.caption' | translate }}
      </span>
    </div>

    <div class="admin-event-analytics-groups-table-container">
      <app-datatable
        data-testid="admin-event-analytics-groups-datatable"
        [rowData]="tableRows()"
        [columns]="tableColumns"
        [configurationInput]="tableConfiguration"
        [customColumnDef]="[
          { name: 'campaignCompletion', isSortable: true, template: campaignCompletionColumn },
          { name: 'reportAdoption', isSortable: true, template: reportAdoptionColumn },
          { name: 'briefingAdoption', isSortable: true, template: briefingAdoptionColumn },
          { name: 'avgCompletionTime', isSortable: true, template: avgCompletionTimeColumn },
        ]"
        [total]="total()"
        [loaderConfig]="tableLoaderConfig"
        [isInitialDataLoaded]="isTableDataLoaded()"
        [loadingData]="store.groupsLoading$()"
      />
    </div>

    <ng-template #campaignCompletionColumn let-row="row">
      <span>{{ row.campaignCompletion }}</span>
    </ng-template>

    <ng-template #reportAdoptionColumn let-row="row">
      <span>{{ row.reportAdoption }}</span>
    </ng-template>

    <ng-template #briefingAdoptionColumn let-row="row">
      <span>{{ row.briefingAdoption }}</span>
    </ng-template>

    <ng-template #avgCompletionTimeColumn let-row="row">
      <span>{{ row.avgCompletionTime }}</span>
    </ng-template>
  </div>
</div>
